module.exports = __webpack_public_path__ + "createstatic/media/publish-button.f40e87ca.svg";